




















import Vue from "vue";

// Import Components
import BreadCrumbItem from "./BreadCrumbItem.vue";

export default Vue.extend({
  name: "BreadCrumb",
  props: {
    entries: {
      type: Array,
      required: true,
    },
    fixedTop: {
      type: Boolean,
      required: false,
    },
  },
  inject: {
    components: {
      default: {
        BreadCrumbItem,
      },
    },
  },
});
